import service from "@/api/axios";
import { AddModelRequest, ModelIdType } from "@/interface/model";
import { TrainingHistoryRequest } from "@/interface/training";
import { ACHIEVEMENT, LearningLogRequest } from "@/interface/learning";
import {
  ACHIEVEMENT_URL,
  FEEDBACK_URL,
  LEARNING_LOG_URL,
  SAVED_MODEL_URL,
  TRAINING_HISTORY_URL,
  ANNOUNCE_MAIL_URL,
  GEN_MODEL_PIC_URL,
} from "@/constants/urls";

export const getSavedModel = () => service.get(SAVED_MODEL_URL);

export const addSavedModel = (data: AddModelRequest) =>
  service.post(SAVED_MODEL_URL, data);

export const editSavedModel = (id: ModelIdType, data: AddModelRequest) =>
  service.put(`${SAVED_MODEL_URL}${id}/`, data);

export const genModelPicture = (data: AddModelRequest) =>
  service.post(GEN_MODEL_PIC_URL, data);

export const deleteSavedModel = (id: ModelIdType) =>
  service.delete(`${SAVED_MODEL_URL}${id}/`);

export const getTrainingHistory = () => service.get(TRAINING_HISTORY_URL);

export const addTrainingHistory = (data: TrainingHistoryRequest) =>
  service.post(TRAINING_HISTORY_URL, data);

export const deleteTrainingHistory = (id: string) =>
  service.delete(`${TRAINING_HISTORY_URL}${id}/`);

export const addLearningLog = (data: LearningLogRequest) =>
  service.post(LEARNING_LOG_URL, data);

export const getAchievement = () => service.get(ACHIEVEMENT_URL);

  export const patchAchievement = (id: number, achievement: ACHIEVEMENT) =>
  service.patch(`${ACHIEVEMENT_URL}${id}/`, { [achievement]: true });

  export const addFeedback = (content: string) =>
  service.post(FEEDBACK_URL, { content });

  export const addAnnounceMail = (emailContent: string) =>
  service.post(ANNOUNCE_MAIL_URL, { emailContent });

